import React from 'react';
import { Typography } from '@mui/material';
import { isRichTextHtml } from '../../utils/isRichTextHtml';
import { sanitizeHtml } from '../../utils/sanitizeHtml';

interface QuestionHelpTextProps {
  description?: string;
  className?: string;
}

function QuestionHelpText({ description, className = '' }: QuestionHelpTextProps): JSX.Element | null {
  if (!description?.trim()) return null;

  const richText = isRichTextHtml(description);
  return (
    <Typography
      component="div"
      variant="body2"
      color="textSecondary"
      className={`cla-quiz-help-text ${className}`.trim()}
      sx={{
        mb: 2,
        overflowWrap: 'anywhere',
        whiteSpace: richText ? 'normal' : 'pre-wrap',
        '& p': { mt: 0, mb: 1 },
        '& ul, & ol': { mt: 0, mb: 1, pl: 3 },
        '& li': { mb: 0.5 },
        '& > :last-child': { mb: 0 },
        '& a': { color: 'primary.main', textDecoration: 'underline' },
      }}
      {...(richText
        ? { dangerouslySetInnerHTML: { __html: sanitizeHtml(description) } }
        : { children: description })}
    />
  );
}

export default QuestionHelpText;